import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 22.1 19.86"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M15.2 0c-1.93 0-3.31.81-4.15 1.52A6.34 6.34 0 0 0 6.9 0C2.77 0 0 3.86 0 7.47c0 1.63.58 3.3 1.71 4.98.87 1.29 2.08 2.58 3.6 3.83 1.37 1.14 2.7 2.01 3.57 2.54.55.33.97.56 1.22.7.16.08.29.15.39.2.05.02.1.05.16.07.02 0 .06.02.09.03s.16.05.29.05c.14 0 .26-.03.29-.04l.11-.04c.05-.02.1-.04.15-.07.1-.05.23-.11.39-.2.25-.13.67-.37 1.22-.7.87-.53 2.2-1.41 3.57-2.54 1.51-1.25 2.72-2.54 3.6-3.83 1.13-1.67 1.71-3.35 1.71-4.98 0-3.61-2.77-7.47-6.9-7.47Zm4.97 7.47c0 1.24-.46 2.55-1.38 3.89-.78 1.14-1.86 2.3-3.23 3.44a29 29 0 0 1-3.34 2.38c-.49.3-.88.51-1.12.64l-.05.03-.05-.02c-.25-.13-.65-.35-1.12-.64-.82-.5-2.06-1.31-3.34-2.38-1.37-1.14-2.46-2.3-3.23-3.44-.91-1.35-1.38-2.66-1.38-3.89 0-2.69 2-5.55 4.97-5.55 1.69 0 2.79.86 3.42 1.58.18.21.45.33.73.33s.54-.12.73-.33c.63-.72 1.73-1.58 3.42-1.58 2.97 0 4.97 2.86 4.97 5.53Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }